import { render } from "./ChatMensajes.vue?vue&type=template&id=0ec67066&scoped=true"
import script from "./ChatMensajes.vue?vue&type=script&lang=js"
export * from "./ChatMensajes.vue?vue&type=script&lang=js"

import "./ChatMensajes.vue?vue&type=style&index=0&id=0ec67066&lang=css"
import "./ChatMensajes.vue?vue&type=style&index=1&id=0ec67066&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec67066"]])

export default __exports__